import {
  EVENT_TYPE_ICON,
  EventType,
  Module,
  TeamType,
  EventQuestionType,
} from "../enums";
import IconMusicNote from "@mui/icons-material/MusicNote";
import { DynamicIcon } from "../components/DynamicIcon/DynamicIcon";

export function getEventIcon(
  eventType: EventType,
  eventModules: any[],
  eventTheme: any = undefined,
) {
  if (eventTheme && eventTheme.icon) {
    return <DynamicIcon iconName={eventTheme.icon.code} />;
  } else if (
    eventModules &&
    eventModules.filter(
      (eventModule: any) =>
        eventModule.module === Module.TOWERS &&
        eventModule.team &&
        eventModule.team.type === TeamType.MUSICIANS,
    ).length > 0
  ) {
    return <IconMusicNote />;
  }
  return EVENT_TYPE_ICON[eventType];
}

export function getEventUsers(event: any, users: any[]) {
  if (
    event.modules.filter(
      (eventModule: any) =>
        eventModule.module === Module.TOWERS && !eventModule.team,
    ).length > 0
  ) {
    return users;
  }
  return users.filter(
    (user: any) =>
      event.modules.filter(
        (eventModule: any) =>
          eventModule.module === Module.TOWERS &&
          eventModule.team &&
          user.members &&
          user.members.filter(
            (member: any) => eventModule.team.id === member.team.id,
          ).length > 0,
      ).length > 0,
  );
}

export function eventPriceToTitle(t: any, eventPrice: any) {
  return eventPrice.age_from && eventPrice.age_to
    ? t("pages.calendar-event.register.prices.between") +
        " " +
        eventPrice.age_from +
        " " +
        t("pages.calendar-event.register.prices.and") +
        " " +
        eventPrice.age_to +
        " " +
        t("pages.calendar-event.register.prices.years")
    : eventPrice.age_from
      ? t("pages.calendar-event.register.prices.above") +
        " " +
        eventPrice.age_from +
        " " +
        t("pages.calendar-event.register.prices.years")
      : eventPrice.age_to
        ? t("pages.calendar-event.register.prices.under") +
          " " +
          eventPrice.age_to +
          " " +
          t("pages.calendar-event.register.prices.years")
        : t("pages.calendar-event.register.prices.general-admission");
}

export function getEventQuestionAnswer(
  t: any,
  locale: string,
  eventQuestion: any,
  value: any,
) {
  if (value == null) {
    return value;
  }

  if (eventQuestion.type === EventQuestionType.BOOLEAN) {
    return value ? t("common.boolean.yes") : t("common.boolean.no");
  } else if (eventQuestion.type === EventQuestionType.CHOICE) {
    const eventAnswers = eventQuestion.data.choices;
    const eventAnswersLocale = eventAnswers[locale];

    return eventAnswersLocale[value];
  }

  return value;
}
